import React from "react"
import EditItem from "./EditItem"
import Item from "./Item"

export default class List extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            editId: null
        }
    }

    setEdit = (tempId) => {
        this.setState({ editId: tempId })
    }

    render() {
        const { list = [], updateList, deleteItem } = this.props
        const { editId } = this.state
        return (
            <div style={{ ...style.wrapper }}>
                <div style={{ ...style.headline }}>
                    <h6>{"לא תקפים:"}</h6>
                    <div style={{ ...style.index }}>
                        <span style={{ fontWeight: 'bold' }}>{"מקרא: "}</span>
                        <span style={{ color: 'red' }}>{"api & crm"}</span>
                        <span style={{ color: 'orange' }}>{"api"}</span>
                        <span style={{ color: 'purple' }}>{"crm"}</span>
                    </div>
                </div>
                <div style={{ ...style.list }}>
                    {list.map((user, idx) => {                  
                        return editId === user.tempId ?
                            <EditItem user={user} setEdit={this.setEdit} updateList={updateList} key={idx.toString()}/> :
                            <Item user={user} deleteItem={deleteItem}  edit={this.setEdit} key={idx.toString()}/>
                    })}
                    {list.length === 0 &&
                        <span style={{ alignSelf: 'center' }}>{"כל המשתמשים תקפים"}</span>}
                </div>
            </div>
        )
    }
}

const style = {
    wrapper: { marginTop: '30px' },
    headline: { display: 'flex', justifyContent: 'space-between' },
    index: { display: 'flex', width: '300px', justifyContent: 'space-between', marginLeft: '30px' },
    list: {
        display: 'flex',
        flexDirection: 'column',
        padding: '20px 10px',
        backgroundColor: 'white',
        borderRadius: '10px'
    }
}